import { render, staticRenderFns } from "./store-inactive.vue?vue&type=template&id=aaf52ffc&scoped=true&"
import script from "./store-inactive.vue?vue&type=script&lang=js&"
export * from "./store-inactive.vue?vue&type=script&lang=js&"
import style0 from "./store-inactive.vue?vue&type=style&index=0&id=aaf52ffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf52ffc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
